import EventEmitter from './EventEmitter.js'

export default class Sizes extends EventEmitter
{
    /**
     * Constructor
     */
    constructor()
    {
        super()

        // Viewport size
        this.viewport = {}

        // Resize event
        this.resize = this.resize.bind(this)
        window.addEventListener('resize', this.resize)
        window.addEventListener('orientationchange', () =>
        {
            this.resize()
            window.setTimeout(this.resize, 100)
            window.setTimeout(this.resize, 400)
        })

        if(window.visualViewport)
        {
            window.visualViewport.addEventListener('resize', this.resize)
            window.visualViewport.addEventListener('scroll', this.resize)
        }

        this.resize()
    }

    /**
     * Resize
     */
    resize()
    {
        const viewport = window.visualViewport
        const width = viewport ? viewport.width : window.innerWidth
        const height = viewport ? viewport.height : window.innerHeight

        this.viewport.width = width
        this.viewport.height = height
        this.width = width
        this.height = height

        this.trigger('resize')
    }
}
